(function(){
	"use strict";
	var ENGRAVING_VARIANT_ID_DEFAULT = 54080600473943;
	
	function initBlocks() {
		document.querySelectorAll('[data-initials-block]').forEach(function(block){
			if (block.dataset.lnInit) return;
			block.dataset.lnInit = "1";
			var toggle = block.querySelector('[data-initials-toggle]');
			var inputWrap = block.querySelector('[data-initials-input-wrap]');
			var input = block.querySelector('[data-initials-input]');
			if (!toggle || !inputWrap || !input) return;
			toggle.addEventListener('change', function(){
				if (this.checked) {
					inputWrap.removeAttribute('hidden');
					input.setAttribute('required','required');
					setTimeout(function(){ input.focus(); }, 50);
				} else {
					inputWrap.setAttribute('hidden','');
					input.removeAttribute('required');
					input.value = '';
				}
			});
			input.addEventListener('input', function(){
				this.value = this.value.toUpperCase().replace(/[^A-Z]/g,'').substring(0,3);
			});
		});
	}
	
	// Intercept form submit
	document.addEventListener('submit', function(e){
		var form = e.target;
		if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
		var block = form.querySelector('[data-initials-block]');
		if (!block) return;
		var toggle = block.querySelector('[data-initials-toggle]');
		var input = block.querySelector('[data-initials-input]');
		if (!toggle || !toggle.checked) return;
		if (!input || !input.value.trim()) return;
		
		e.preventDefault();
		e.stopImmediatePropagation();
		
		var initials = input.value.trim().toUpperCase();
		var mainIdEl = form.querySelector('[name="id"]');
		var mainVariantId = mainIdEl ? mainIdEl.value : null;
		if (!mainVariantId) return;
		var qtyEl = form.querySelector('[name="quantity"]');
		var quantity = qtyEl ? parseInt(qtyEl.value || 1, 10) : 1;
		
		var btn = form.querySelector('button[type="submit"], .single-add-to-cart-button');
		if (btn) btn.setAttribute('disabled','');
		
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {'Content-Type':'application/json','Accept':'application/json'},
			body: JSON.stringify({
				items: [
					{ id: mainVariantId, quantity: quantity, properties: { 'Initials': initials } },
					{ id: (parseInt(block.dataset.engravingVariant, 10) || ENGRAVING_VARIANT_ID_DEFAULT), quantity: quantity, properties: { 'For product': mainVariantId, 'Initials': initials } }
				]
			})
		}).then(function(r){ return r.json(); }).then(function(data){
			if (btn) btn.removeAttribute('disabled');
			// Refresh & open cart drawer
			document.dispatchEvent(new CustomEvent('cart:refresh'));
			document.dispatchEvent(new CustomEvent('cart:build'));
			var drawer = document.querySelector('cart-drawer');
			if (drawer) {
				try { drawer.open && drawer.open(); } catch(e){}
				try { drawer.showModal && drawer.showModal(); } catch(e){}
				try { drawer.classList.add('active','open'); } catch(e){}
			} else {
				window.location.href = '/cart';
			}
		}).catch(function(err){
			if (btn) btn.removeAttribute('disabled');
			alert('Error: ' + err.message);
		});
	}, true);
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initBlocks);
	} else {
		initBlocks();
	}
	// Re-init on section reload (theme editor)
	document.addEventListener('shopify:section:load', initBlocks);
})();